export default function () {
  // TODO: remove after real partials
  // console.log('show!!!')
}
